import script from "./CustomTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomTable.vue?vue&type=script&setup=true&lang=js"

import "./CustomTable.vue?vue&type=style&index=0&id=1840a51e&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1840a51e"]])

export default __exports__